// @flow

import { appNavigate } from '../app/actions';
import { setJWT, setJwtStorage } from '../base/jwt';
import { setAttendanceApi, setuserDetails } from '../base/mtApi';
import { toState } from '../base/redux';
import { updateSettings } from '../base/settings';
import { areThereNotifications } from '../notifications';
import { getOverlayToRender } from '../overlay';

// import { iAmVisitor } from '../visitors/functions';

/**
 * Tells whether or not the notifications should be displayed within
 * the conference feature based on the current Redux state.
 *
 * @param {Object|Function} stateful - The redux store state.
 * @returns {boolean}
 */
export function shouldDisplayNotifications(stateful) {
    const state = toState(stateful);
    const isAnyOverlayVisible = Boolean(getOverlayToRender(state));
    const { calleeInfoVisible } = state['features/invite'];

    return areThereNotifications(state)
      && !isAnyOverlayVisible
      && !calleeInfoVisible;
}


/**
 * Hang up for React Native.
 *
 * @returns {any}
 */
export function hangUpReactNative() {
    return (dispatch: Dispatch<any>) => {
        dispatch(setAttendanceApi(true));

        dispatch(appNavigate(undefined));

        // console.log('fffee', );
        // dispatch(appNavigate(undefined));

        setTimeout(() => {
            dispatch(setuserDetails(null));
            dispatch(updateSettings({
                serverURL: undefined,
                accessToken: undefined,
                avatarURL: undefined,
                email: null,
                displayName: null
            }));
            dispatch(setJwtStorage(null));
            dispatch(setJWT(null));
        }, 1000);

        return;
    };
}


/**
 *
 * Returns true if polls feature is disabled.
 *
 * @param {(Function|Object)} stateful - The (whole) redux state, or redux's
 * {@code getState} function to be used to retrieve the state
 * features/base/config.
 * @returns {boolean}
 */
export function arePollsDisabled(stateful) {
    const state = toState(stateful);

    // return state['features/base/config']?.disablePolls || iAmVisitor(state);
    return state['features/base/config']?.disablePolls;
}

